import Vue from 'vue' 
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import 'core-js'
import Inputmask from "inputmask";

import Home from './../vue/Home'
import { all } from 'core-js/fn/promise';
/* Example class */
//import ExampleClass from './example.js'
//const exampleClass = new ExampleClass()
//exampleClass.helloWorld()

/* Vue instance 
new Vue({
  el: '#app',
  render: h => h(Home)
})*/ 

$("document").ready(function() {

  $('.hamburger').click(function() { 
    $(this).toggleClass('is-active');
    $('.mobileMenu').slideToggle();
    return false;
  });
  if ($('.counting').length > 0) {
  $('.counting').counterUp({
      delay: 10,
      time: 1000
  });
}
  if ($('.tabNav').length > 0) {
  $('.tabNav a').click(function() { 
    $('.tabNav a').removeClass('active');
    $(this).toggleClass('active');
    var what = $(this).attr('href');
    $('.tabs').removeClass('active');
    $(what).toggleClass('active');

    return false;
  });
}
if ($('.toggleMenu').length > 0) {
  $('.toggleMenu').click(function() { 
    $(this).toggleClass('is-active');
    $(this).parent().find('.targetMenu').slideToggle();
    return false;
  });
}
if ($('.doctorBtn a.iframe').length > 0) {
  $('.doctorBtn a.iframe').click(function() { 
    var what = $(this).attr('href');
    $(what).slideToggle();
    return false;
  });
}
  

   
  $('.mobileMenu .menu-item-has-children > a').click(function() { 
    
    $(this).parent().find('.sub-menu').slideToggle();
    return false;
  });
  
  
  
  if ($('.noticeSav').length > 0) {
    var theID = $('.noticeSav').attr('id');
    var cookieID = 'cookie-'+$('.noticeSav').attr('id');

    if(!Cookies.get(cookieID)) {
      setTimeout(function() {
          $('#'+theID).show();
      }, 1000); //set a more realistic time
    }
    $('.noticeSav .close').click(function() {
      Cookies.set(cookieID, '1', { expires: 1 });
      $('.noticeSav').hide();
      return false;
    });
    

  }
  if ($('.selectRow').length > 0) {
    $('.accordionHeader').click(function() { 
      $(this).parent().toggleClass('active');
      $(this).parent().find('.accordionContent').slideToggle();

      
      return false;
    });


  }
  if ($('.accordion').length > 0) {
    $('.accordionHeader').click(function() { 
      $(this).parent().toggleClass('active');
      $(this).parent().find('.accordionContent').slideToggle();

      
      return false;
    });


  }
  if ($('.arakNav').length > 0) {
    $('.arakNav a').click(function() { 
      var what = $(this).attr('href');
      $('.arakNav a').removeClass('active');
      $(this).addClass('active');
      $('.arTab').hide();
      $(what).show();
      
      return false;
    });
  }
  
  if ($('.sajtoGridRight').length > 0) {
    resizeGrid();
    $( window ).resize(function() {
      resizeGrid();
    });
    function resizeGrid() {
      if($(window).width()>990) {
        var leftHeight = $('.sajtoGridLeft').outerHeight();
        var rightHeight = $('.sajtoGridRight').outerHeight();
        
        if(rightHeight<leftHeight) {
          $('.sajtoGridRight').css('height',leftHeight-25+'px');
        }
      }

    }
  }
  if ($('#szakList').length > 0) {

    $('.tipusSelect').click(function() { 
      if($(this).hasClass('selectedItem')) {
        $(this).removeClass('selectedItem');
      } else {
        $(".tipusValto a").removeClass('selectedItem');
        $(this).addClass('selectedItem');
      }
      var helyszin = $('.locationSelect.selectedItem').data('helyszin');
      var tipus = $(this).data('tipus');
      $('#szakteruletList .loading').show();
      filter_szakterulet(helyszin,tipus);

      checkIfActive();
      return false;
    });
    
    $('.szakteruletSelect').click(function() { 
      if($(this).hasClass('selectedItem')) {
        $(this).removeClass('selectedItem');
      } else {
        $("#szakteruletList a").removeClass('selectedItem');
        $(this).addClass('selectedItem');
      }

      checkIfActive();
      return false;
    });
    $('.locationSelect').click(function() { 
     
      if($(this).hasClass('selectedItem')) {
        $(this).removeClass('selectedItem');
      } else {
        $("#helyszin a").removeClass('selectedItem');
        $(this).addClass('selectedItem');
      }
      var tipus = $('.tipusSelect.selectedItem').data('tipus');
      var helyszin = $(this).data('helyszin');
      $('#szakteruletList .loading').show();
      filter_szakterulet(helyszin,tipus);

      checkIfActive();
      return false;
    });
    /*$('.letterSelect').click(function() { 
  
      if($(this).hasClass('selectedItem')) {
        $(this).removeClass('selectedItem');
      } else {
        $("#szakorvos a").removeClass('selectedItem');
        $(this).addClass('selectedItem');
      }
      checkIfActive();
      return false;
    });*/

    if ($('#szakList').length > 0) {
      $('#szakList').select2({
        placeholder: 'Válassz szakterületet!'
      });
  
      $('#szakList').on('select2:select', function (e) { 
          var selection = $(this).find(':selected').data('szakterulet');
        //  console.log(selection);
          
      });
    }
    $('#keresesBtn').click(function() { 
 
     
        var szakterulet =  $('#szakList').find(':selected').data('szakterulet');
        var helyszin =  $('.locationSelect.selectedItem').data('helyszin');
        
      //  console.log(szakterulet);
        
     //   console.log(helyszin);
        $(this).addClass('seraching');
        filter_doctors(szakterulet,helyszin);
        
     
      return false;
    });
    function filter_szakterulet(helyszin,tipus) {
    
      $.ajax({
        type: 'post',
        url : admin_url,
        
        data:    { 
            action  : 'filter_szakterulet',               
            helyszin : helyszin,
            tipus : tipus
    
        },
        success: function(data){
          $('#szakResults').html(data);
          //$('#results').html('');
          $('#szakteruletList .loading').hide();
          $('#szakList').select2({
            placeholder: 'Válassz szakterületet!'
          });
      
          $('#szakList').on('select2:select', function (e) { 
              var selection = $(this).find(':selected').data('szakterulet');
          //    console.log(selection);
              
          });


         
        }
      });
    }
    function filter_doctors(szakterulet,helyszin) {
    
      $.ajax({
        type: 'post',
        url : admin_url,
        
        data:    { 
            action  : 'filter_doctors',               
            szakterulet : szakterulet,
            helyszin : helyszin,
           // letter : letter
    
        },
        success: function(data){
          if(!data) {
            $('#results').html("<h5>Sajnos nincs találat! <br /><br /><br /><br /><br />");
          } else {
            $('#results').html(data);
            var what = $('.totalResults').data('result');
            $('.resultCountBar').html(what+' találat');
          }
          
          $('#keresesBtn').removeClass('seraching');
            $('.reszletes').click(function() { 
              var what = $(this).data('modal');
              var theTarget = '[data-remodal-id=orvos-'+what+']';
              var inst = $(theTarget).remodal();
              inst.open();
              return false;
            });
            $('.accordionHeader').click(function() { 
              $(this).parent().toggleClass('active');
              $(this).parent().find('.accordionContent').slideToggle();
        
              
              return false;
            });
            $('.doctorBtn a.iframe').click(function() { 
              var what = $(this).attr('href');
              $(what).slideToggle();
              return false;
            });
        }
      });
    }
  }
  function checkIfActive() {
    var allgood = false;
    var selectedItem = $('#szakList').find(':selected');
    if(selectedItem.length>0) {
      allgood= true;
    }
    if($('.locationSelect').hasClass('selectedItem')) {
      allgood= true;
    }
   /* if($('.letterSelect').hasClass('selectedItem')) {
      allgood= true;
    }*/
  
    if(allgood) {
      $("#keresesBtn").removeClass('inactive'); 
    } else {
      $("#keresesBtn").addClass('inactive'); 
    }
  }
  
  

  
  

  
  if ($('.kozpontCarousel').length > 0) {
  
    $('.kozpontCarousel').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1
  });

  }  
  
  if ($('.idopontFoglalas').length > 0) {
    $('.idopontFoglalas').click(function() {
      $('.idopontfoglal').show();
      return false;
    });
  }

  if ($('.gombPass').length > 0) {
    $('.gombPass .orange').click(function() {
      var what = $(this).data('gomb');
      $(what).show();
      
    });
    $('.passwordCheck').click(function () {
      var pass = $('#passInput').val();
      var correct = $('#realPass').val();
      var destination = $(this).data('redirect');
      if(pass==correct){
        window.location.href = destination;
      } else {
        $('.buttonForm .error').show();
      }
      return false;
    });
  }
  

  if ($('.homepopup').length > 0) {
    var inst = $('[data-remodal-id=popupRemodal]').remodal();
    inst.open();
  }
  
  if ($('.carousel').length > 0) {
  
    $('.carousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
      {
          breakpoint: 1280,
          settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: false,
          arrows: true

          }
      },
      {
          breakpoint: 990,
          settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: true
          }
      },
      {
          breakpoint: 768,
          settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true
          }
      },
      {
          breakpoint: 575,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true
          }
      }

      ]
  });

  }

  if ($('.testimonialCarousel').length > 0) {
  
    $('.testimonialCarousel').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
      {
          breakpoint: 1200,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false

          }
      },
      {
          breakpoint: 990,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
          }
      },
      {
          breakpoint: 768,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: true
          }
      }

      ]
  });

  }

  

  if ($('.gallery').length > 0) {
 
    $('a.gallery').featherlightGallery({
      previousIcon: '&#9664;',     
      nextIcon: '&#9654;',         
      galleryFadeIn: 100,          
      galleryFadeOut: 300          
    });
  }
  if ($('.flexslider').length > 0) {
    $('.flexslider').flexslider({
      animation: "fade",      
      directionNav: true,
      animationLoop: true,
      controlNav: true,
      pauseOnHover: false,
      slideshowSpeed: 5000, 
      prevText: "",
      nextText: ""
  });
  }


  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
        $('html, body').animate({
        scrollTop: target.offset().top-200
        }, 1000);
        return false;
    }
    }
});


const arlista = document.getElementById('arakContainer');
if(arlista) {


}





});